<template>
    <div class="row">
      <!-- General Top Bar -->
      <!-- <general-top-bar :title="$t('pages.orderDisplayScreen')"></general-top-bar> -->
      <!-- End General Top Bar -->
      <div class="box-container row">
        <div 
          v-for="(route, index) in screenRoutes" 
          :key="route.name" 
          class="col-md-4"
        >
          <router-link 
          :to="route.path" 
          class="box" 
          :style="{ backgroundColor: getBoxColor(index) }"
          >
          <div class="title">{{ $t('pages.' + route.key) }}</div>
          <div class="image">
            <img :src="getImageForRoute(route.key)" :alt="'Image for ' + route.key" />
          </div>
         </router-link>
        </div>
        </div>
    </div>
</template>
    
  <script>
    // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
    
    export default {
      components: {
        // GeneralTopBar
      },
      data () {
        return {
          screenRoutes: [
            { path: '/screens/tabs?tabIndex=0', key: 'ods' },
            { path: '/screens/tabs?tabIndex=1', key: 'posScreen' },
            { path: '/screens/tabs?tabIndex=2', key: 'digitalSignage' }
          ]
        }
      },
      methods: {
        getImageForRoute (routeKey) {
          const images = {
            ods: 'static/img/ods.png',
            posScreen: 'static/img/posScreen.png',
            digitalSignage: 'static/img/digitalSignage.png'
          }
          return images[routeKey] || 'static/img/default.jpg'
        },
        getBoxColor (index) {
          const colors = [
            '#3AB7CD',
            '#674bd2',
            '#20bfab'
          ]
          return colors[index] || '#FFFFFF' // Default color
        }
      }
    }
    </script>
    
    <style scoped>
     .box-container.row {
      max-width: 940px;
      margin: auto;
      display: flex;
      justify-content: center;
    }
    .box-container.row .image {
      position: absolute;
      bottom: 0;
    }
    .box {
      position: relative;
      margin-bottom: 30px;
      text-align: center;
      display: block;
      text-decoration: none;
      color: inherit;
      border-radius: 30px;
      width: 280px;
      height: 280px;
    }
    .title {
      margin-bottom: 8px;
      padding: 30px 0px;
      color: #fff;
      font-size: 20px;
      font-weight: 500;
    }
    .image img {
      width: 100%;
      height: auto;
      max-width: 100%;
      display: block;
      margin: 0 auto 0px;
      border-top-right-radius: 50px;
      border-bottom-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  </style>
    


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Screens/OrderScreen/OrderScreenView.vue